import { render, staticRenderFns } from "./TextTopics.vue?vue&type=template&id=90806512&scoped=true&"
import script from "./TextTopics.vue?vue&type=script&lang=js&"
export * from "./TextTopics.vue?vue&type=script&lang=js&"
import style0 from "./TextTopics.vue?vue&type=style&index=0&id=90806512&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90806512",
  null
  
)

export default component.exports